
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14cnr_8y9wj_93",
  "trigger": "awsui_trigger_14cnr_8y9wj_130",
  "dropdown": "awsui_dropdown_14cnr_8y9wj_133",
  "nowrap": "awsui_nowrap_14cnr_8y9wj_144",
  "open": "awsui_open_14cnr_8y9wj_147"
};
  